module.exports = __webpack_public_path__ + "img/statistiken.ce9f62d9.png";